/** The defaults and ceilings of an onboarding session. */
export const ONBOARDING_LIMITS = {
    defaultMaxApplications: 30,
    maxMaxApplications: 500,
    maxNameLength: 120,
    maxPrivacyNoticeLength: 4000,
    /** The headline of the landing: a line, not a paragraph. */
    maxLandingTitleLength: 80,
    /** Applications listed in one go. */
    maxListed: 200,
};
